import { Component } from '@angular/core';
import {  NavController, NavParams, MenuController } from 'ionic-angular';
import { BuscadorPage } from '../buscador/buscador';

/**
 * Generated class for the TelefonosGeneralesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-telefonos-generales',
  templateUrl: 'telefonos-generales.html',
})
export class TelefonosGeneralesPage {

  constructor(public navCtrl: NavController, public navParams: NavParams,public menuCtrl:MenuController) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad TelefonosGeneralesPage');
  }
  toggleMenu() {
    this.menuCtrl.toggle();
  }
  goToBuscar(){
    this.navCtrl.push(BuscadorPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/telefonos-generales/telefonos-generales.ts